var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73522 23.5191H11.768C11.768 24.138 12.015 24.7315 12.4546 25.169C12.8942 25.6066 13.4905 25.8525 14.1122 25.8525C14.734 25.8525 15.3303 25.6066 15.7699 25.169C16.2095 24.7315 16.4565 24.138 16.4565 23.5191H23.4893C23.8001 23.5191 24.0983 23.3962 24.3181 23.1774C24.5379 22.9586 24.6614 22.6619 24.6614 22.3525C24.6614 22.043 24.5379 21.7463 24.3181 21.5275C24.0983 21.3087 23.8001 21.1858 23.4893 21.1858V13.0191C23.4893 10.5438 22.5013 8.1698 20.7428 6.41946C18.9843 4.66912 16.5992 3.68579 14.1122 3.68579C11.6253 3.68579 9.24022 4.66912 7.48168 6.41946C5.72315 8.1698 4.73522 10.5438 4.73522 13.0191V21.1858C4.42435 21.1858 4.12621 21.3087 3.9064 21.5275C3.68658 21.7463 3.56309 22.043 3.56309 22.3525C3.56309 22.6619 3.68658 22.9586 3.9064 23.1774C4.12621 23.3962 4.42435 23.5191 4.73522 23.5191ZM7.07947 13.0191C7.07947 11.1626 7.82043 9.38213 9.13933 8.06938C10.4582 6.75662 12.247 6.01912 14.1122 6.01912C15.9775 6.01912 17.7663 6.75662 19.0852 8.06938C20.4041 9.38213 21.145 11.1626 21.145 13.0191V21.1858H7.07947V13.0191Z",
    fill: "#683C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotf);
export default __webpack_public_path__ + "static/media/notf.adf2020d21e88089a5961b2d6e8df488.svg";
export { ForwardRef as ReactComponent };